<template>
  <div class="InformationList">
    <div class="header">
      <div class="header_l">
        <div class="header_l_t">
          <span v-if="isHome">广场信息 </span>
          <span v-else>信息栏</span>
          <span class="solid">｜</span>
          <span class="desc">可发布行业内相关信息，提高信息传播率</span>
        </div>
        <div class="header_l_b">
          <span class="text_6">信息量：</span>
          <span class="text_9">{{ tranNumber(PlazaMessageProfile.totalMessageCount) }}</span>
          <span class="solid">｜</span>
          <span class="text_6">浏览量：</span>
          <span class="text_9">{{ tranNumber(PlazaMessageProfile.totalViewCount)  }}</span>
          <span class="solid">｜</span>
          <span class="text_6">评论量：</span>
          <span class="text_9">{{ tranNumber(PlazaMessageProfile.commentCount) }}</span>
        </div>
      </div>
      <div class="header_r">
        <!-- <div class="desc myList" @click="toMyList">
          <el-badge :is-dot="showDot">
            我的发布：
            {{ PlazaMessageProfile.myPublishCount }}
          </el-badge>
        </div> -->

        <el-button type="primary" @click="toForm">发布</el-button>
      </div>
    </div>
    <div class="list">
      <el-table
        row-class-name="defTableRowStyle"
        header-row-class-name="defTableHeaderStyle"
        :data="list"
        style="width: 100%"
        v-loading="listLoading"
        @cell-mouse-enter="cellMouseEnter"
        @cell-mouse-leave="cellMouseLeave"
      >
        <el-table-column label="信息">
          <template slot-scope="scope">
            <div style="padding-bottom: 18px" @click="toDetail(scope.row.messageId)">
              <div
                class="pointer keep2lines"
                style="font-size: 14px; font-weight: 400; color: #262626"
                :style="
                  cellMouseData?.messageId == scope.row.messageId
                    ? { color: '#0062FF' }
                    : {}
                "
              >
                {{ scope.row.content }}
              </div>
              <imageBox
                v-if="scope.row.type === 1"
                :url="scope.row.url"
                style="margin-top: 8px"
                :preview="false"
              />
              <videoBox
                v-else-if="scope.row.type === 2"
                :imgUrl="scope.row.coverUrl"
                :url="scope.row.url"
                style="margin-top: 8px"
                :preview="false"
              />
            </div>
          </template>
        </el-table-column>

        <el-table-column label="浏览" width="80">
          <template slot-scope="scope">
            <div>
              {{ tranNumber(scope.row.viewCount) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="评论" width="80">
          <template slot-scope="scope">
            <div>
              {{tranNumber(scope.row.commentCount)  }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="发布者" width="140">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center; gap: 6px">
              {{ scope.row.authorName }}
              <img
                src="@/assets/image/shiming.webp"
                class="shimingicon"
                alt=""
                srcset=""
                v-if="scope.row.authorState == 1"
              />
              <img
                src="@/assets/image/shiming2.webp"
                class="shimingicon"
                alt=""
                srcset=""
                v-if="scope.row.authorState == 2"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" width="120">
          <template slot-scope="scope">
            <div>
              {{ renderTime(scope.row.updatedAt) }}
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <empty />
        </template>
      </el-table>
      <div class="pagination">
        <div class="pagination_left">
          <div v-if="isHome" class="all" @click="$router.push({ name: 'Information' })">
            查看全部
          </div>
        </div>
        <el-pagination
          :current-page="parm.current"
          :page-sizes="[30, 40, 50, 60]"
          :page-size.sync="parm.size"
          popper-class="paginationTopStyle"
          background
          layout="total,  prev, pager, next, jumper"
          :total="parm.total"
          @size-change="sizeChange"
          @current-change="currentChange"
          :popper-options="{
            placement: 'top',
            boundariesPadding: 10,
          }"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import getList from "@/mixins/getList";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/zh-cn";
import userinfo from "@/mixins/userinfo";
import imageBox from "./imageBox.vue";
import videoBox from "./videoBox.vue";
import { mapActions } from "vuex";
import utils from '@/utils/utils.js'
export default {
  components: {
    imageBox,
    videoBox,
  },
  props: {
    isHome: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [getList, userinfo],
  data() {
    return {
      listParm: {},
      PlazaMessageProfile: {
        totalMessageCount: 0,
        totalViewCount: 0,
        myPublishCount: 0,
        pendingUnreadCount: 0,
        approvedUnreadCount: 0,
        rejectedUnreadCount: 0,
      },
    };
  },
  created() {},
  computed: {
    showDot() {
      if (
        this.PlazaMessageProfile.pendingUnreadCount > 0 ||
        this.PlazaMessageProfile.approvedUnreadCount > 0 ||
        this.PlazaMessageProfile.rejectedUnreadCount > 0
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {},
  methods: {
    tranNumber(res){
      return utils.tranNumber(res)
    },
    ...mapActions("information", ["detailOnShow"]),
    getListCallback(res) {
      this.getPlazaMessageProfile();
    },
    listApi(parm) {
      let data = { ...parm, ...this.listParm };
      const status = this.$route.query.status;
      if (status !== undefined) {
        data.status = status;
      }
      return this.$api.getPlazaMessageList(data);
    },
    renderTime(time) {
      dayjs.locale("zh-cn");
      dayjs.extend(relativeTime);
      const timestamp = time * 1000; // 转换为毫秒
      const fromNow = dayjs(timestamp).fromNow();
      return fromNow;
    },
    async toForm() {
      await this.verifyUserAuth();
      // await this.verifyCompanyAuth();
      this.$router.push({ name: "InformationForm" });
    },
    async toMyList() {
      await this.verifyUserAuth();
      // await this.verifyCompanyAuth();
      let status = 0;
      if (this.PlazaMessageProfile.pendingUnreadCount > 0) {
        status = 1;
      }
      if (this.PlazaMessageProfile.rejectedUnreadCount > 0) {
        status = 2;
      }
      this.$router.push({
        path: "/Information/InformationMy",
        query: {
          status,
        },
      });
      // this.$router.push({ name: "InformationMy" });
    },
    async getPlazaMessageProfile() {
      const { data, status } = await this.$api.getPlazaMessageProfile();
      if (status === 200) {
        this.PlazaMessageProfile = data;
      }
    },
    toDetail(id) {
      this.detailOnShow(id);
    },
  },
};
</script>

<style scoped lang="scss">
.InformationList {
  border-radius: 4px;
  padding: 0 16px;
  background: #ffffff;
  margin-bottom: 50px;
  .header {
    height: 74px;
    padding: 15px 0;
    display: flex;
    justify-content: space-between;
    &_l {
      display: flex;
      flex-direction: column;
      justify-content: center;
      &_t {
        font-size: 16px;
        font-weight: 500;
        color: #262626;
        .desc {
          font-size: 12px;
          color: #666666;
          font-weight: normal;
        }
      }
      &_b {
        font-weight: 350;
        font-size: 12px;
        margin-top: 7px;
      }
    }
    &_r {
      display: flex;
      align-items: center;
      gap: 20px;
      .desc {
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        color: #666666;
      }
    }
    .text_e {
      color: #eee;
    }
    .text_6 {
      color: #666;
    }
    .text_9 {
      color: #999;
    }
    .solid {
      font-size: 12px;
      color: #eeeeee;
    }
  }
  .pagination {
    display: flex;
    height: 60px;
    align-items: center;
    justify-content: space-between;
    .all {
      font-size: 14px;
      color: #666666;
      transition: all 0.3s;
      cursor: pointer;
      &:hover {
        color: #0062ff;
      }
    }
  }
  .list {
    @include tableTopAlignStyle;
  }
}
.shimingicon {
  width: 10.4px;
  height: 13px;
}
.myList {
  cursor: pointer;
  line-height: 1;
  &:hover {
    color: #0062ff;
  }
  &::v-deep .el-badge {
    &__content {
      right: 2px !important;
      top: 6px !important;
    }
  }
}
</style>
